import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

const ReferencesSection = () => {
  const { lang, t } = useI18n();
  const refs = t.refs.items[lang];
  const known = t.refs.known[lang];

  return (
    <section id="refs" className="py-16 md:py-20 bg-background">
      <div className="container mx-auto px-6 max-w-[960px]">
        <div className="grid md:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="section-label mb-3">{t.refs.label[lang]}</div>
            <h2 className="font-display text-2xl md:text-3xl text-foreground mb-5 leading-[1.1]">
              {t.refs.h2[lang]}
            </h2>
            <div className="flex flex-col gap-3 mt-5">
              {refs.map((r, i) => (
                <div
                  key={i}
                  className={`flex items-center gap-3.5 p-3.5 px-4 border border-border rounded-sm ${i === 0 ? "border-l-[3px] border-l-brand-blue" : ""}`}
                >
                  <div className="w-1.5 h-1.5 bg-brand-blue rounded-full shrink-0" />
                  <div>
                    <div className="font-semibold text-sm text-foreground">{r.name}</div>
                    <div className="text-xs font-light text-muted-foreground">{r.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="section-label mb-3">{t.refs.knownLabel[lang]}</div>
            <h2 className="font-display text-2xl md:text-3xl text-foreground mb-5 leading-[1.1]">
              {t.refs.knownH2[lang]}
            </h2>
            <p className="text-[13.5px] font-light text-brand-text mb-5 leading-[1.65]">
              {t.refs.knownSub[lang]}
            </p>
            <div className="flex flex-col gap-3">
              {known.map((k, i) => (
                <div
                  key={i}
                  className="p-3.5 px-4 bg-brand-off rounded-sm border-l-[3px] border-brand-blue"
                >
                  <div className="font-semibold text-sm text-foreground">{k.name}</div>
                  <div className="text-xs font-light text-muted-foreground">{k.desc}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ReferencesSection;
